import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnmask'
})
export class MaskPipe implements PipeTransform {

  transform(value: string, showMask :boolean): string {
    if (!showMask || value.length < 9) {
      return value;
    }
    return "XXX-XX-" + value.slice(value.length - 4, value.length);
  }
}
